export const buttonConstant = [
  { title: "Javascript", id: "javascript", selected: false},
  { title: "React", id: "react", selected: false},
  { title: "CSS", id: "css", selected: false},
  { title: "SCSS", id: "scss", selected: false},
  { title: "Redux", id: "redux", selected: false},
  { title: "Ant Design", id: "ant-design", selected: false}
];
